/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
// import PropTypes from "prop-types";
import { connect, useDispatch, useSelector } from "react-redux";

import Api from "../../../api";

import audienceSlice from "../../../store/entities/audience/audience-slice.reducer";
import {
  isShareAudienceModalOpenSelector,
  selectedAudienceSelector,
  shareAudienceSelector
} from "../../../store/entities/audience/audience.selectors";
import { Button, Input, ModalView } from "../../simple";

import styles from "./modal-share.module.scss";

const { hideShareAudienceModal } = audienceSlice.actions;

export const ModalShare = () => {
  const dispatch = useDispatch();

  const [state, setState] = useState({ email: "" });

  const isShareAudienceModalOpen = useSelector(
    isShareAudienceModalOpenSelector
  );

  const selectedAudience = useSelector(selectedAudienceSelector);
  const {
    isValidateLoading,
    isValidateSuccess: isShareEmailValidateSuccess,
    validateError: shareValidateEmailError,

    isShareAudienceLoading,
    isShareAudienceSuccess,
    shareError
  } = useSelector(shareAudienceSelector);

  const handleChange = (name, value) => {
    setState({ ...state, email: value });
  };

  useEffect(() => {
    if (isShareAudienceSuccess || !isShareAudienceModalOpen) {
      setState({ email: "" });
    }
  }, [isShareAudienceSuccess, isShareAudienceModalOpen]);

  return (
    <ModalView
      isOpen={isShareAudienceModalOpen}
      changeModalState={() => {
        // callback(false);
        // setConfirmModal(!isConfirmModal);
      }}
      handleClose={() => {
        dispatch(hideShareAudienceModal());
      }}
    >
      <h2 className={`title ${styles.title}`} style={{ marginBottom: "30px" }}>
        Share audience
      </h2>
      <p className={`description ${styles.description}`}>
        Enter valid user email, then confirm share
      </p>

      <div
        style={{
          width: "100%"
        }}
      >
        <form
          style={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            margin: "30px 0 0 0"
          }}
          onSubmit={e => {
            e.preventDefault();
            const audienceId = selectedAudience;
            Api.audience.shareAudienceValidateEmail({
              params: { email: encodeURIComponent(state.email), audienceId }
            });
          }}
        >
          <div style={{ width: "100%", margin: "0 30px 0 0" }}>
            <Input
              type="email"
              // handleChange={() => {}}
              placeholder="Email"
              value={state.email}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              handleChange={handleChange}
              invalid={!!shareValidateEmailError}
              fieldError={
                typeof shareValidateEmailError === "string"
                  ? shareValidateEmailError
                  : shareValidateEmailError?.msg
              }
              required
            />
          </div>

          <Button
            type="submit"
            onClick={() => {}}
            className="button justify-content-center"
            style={{ "min-width": "150px" }}
            isLoading={isValidateLoading}
          >
            Share
          </Button>
        </form>
      </div>

      {shareError ? (
        <div className="alert alert-danger" role="alert">
          {typeof shareError === "string"
            ? shareError
            : JSON.stringify(shareError)}
        </div>
      ) : null}

      {isShareEmailValidateSuccess ? (
        <>
          {/* <div className={styles.userProfile} style={{ marginBottom: "30px" }}>
            <div className={styles.avatar}></div>
            <div className={styles.userName}>Test Testovich</div>
          </div> */}

          <Button
            variant="success"
            onClick={() => {
              const audienceId = selectedAudience;
              Api.audience.shareAudience({
                data: { email: state.email, audienceId }
              });
            }}
            className="button justify-content-center"
            isLoading={isShareAudienceLoading}
          >
            Confirm
          </Button>
        </>
      ) : null}
    </ModalView>
  );
};

ModalShare.propTypes = {
  //   props: PropTypes
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalShare);
